<template>
  <div>
    <menubar :permission="permission" />
    <div class="container">
      <!-- タイトルdivタグ -->
      <div id="title" class="d-flex justify-content-start">
        <img src="/img/05_slash.svg" />
        <p class="h1">ユーザー設定</p>
      </div>
      <!-- 表全体を囲うdivタグ -->
      <div class="usersetting">
        <!-- 表の上側のプロフィール部分のdivタグ -->
        <div class="table_style bottom-border">
          <div class="profile table_cell h6">プロフィール</div>
          <div class="table_cell text-right left-padding">
            <div class="username">ユーザー名</div>
            <div class="mailaddress">メールアドレス</div>
            <div class="pasward">パスワード</div>
          </div>
          <div class="table_cell text-left">
            <div class="username left-padding font-weight">{{ username }}</div>
            <div class="mailaddress left-padding font-weight">
              {{ mailaddress }}
            </div>
            <div class="pasward left-padding font-weight">
              {{ password_hide }}
            </div>
          </div>
          <div class="table_cell">
            <div class="username"></div>
            <div class="mailaddress">
              <!-- メールアドレス変更モーダル -->
              <modal ref="mailaddress_modal">
                <template v-slot:activator="{ openModal }">
                  <button
                    class="btn btn-purple show-modal btn-usersetting"
                    @click="
                      openModal({ is_narrow: true });
                      clearNewItem();
                    "
                  >
                    変更
                  </button>
                </template>
                <!--モーダルタイトル-->
                <template v-slot:modalTitle> メールアドレス変更 </template>
                <!--モーダル内のコンテツ-->
                <template v-slot:modal-content="{ closeModal }">
                  <div class="modal-section">
                    現在のメールアドレス<br />
                    <div class="modal-section__font-big">
                      {{ mailaddress }}
                    </div>
                  </div>
                  <div class="modal-section">
                    新しいメールアドレスを入力<br />
                    <input type="text" v-model="newItem1" />
                  </div>
                  <div class="modal-section">
                    新しいメールアドレスを再入力<br />
                    <input type="text" v-model="newItem2" />
                  </div>
                  <div class="modal-btn d-flex justify-content-evenly">
                    <div>
                      <button class="btn btn-red" @click="closeMailaddressModal()">キャンセル</button>
                    </div>
                    <div>
                      <button class="btn btn-purple" @click="changeMailaddress()">変更</button>
                    </div>
                  </div>
                </template>
              </modal>
            </div>
            <div class="pasward">
              <!-- パスワード変更モーダル -->
              <modal ref="password_modal">
                <template v-slot:activator="{ openModal }">
                  <button
                    class="btn btn-purple show-modal btn-usersetting"
                    @click="
                      openModal({ is_narrow: true });
                      clearNewItem();
                    "
                  >
                    変更
                  </button>
                </template>
                <!--モーダルタイトル-->
                <template v-slot:modalTitle> パスワード変更 </template>
                <!--モーダル内のコンテツ-->
                <template v-slot:modal-content="{ closeModal }">
                  <input type="hidden" name="_token" :value="csrf" />
                  <div class="modal-section">
                    現在のパスワードを入力<br />
                    <input type="password" v-model="newItem0" />
                  </div>
                  <div class="modal-section">
                    新しいパスワードを入力（8文字以上の半角英数）<br />
                    <input type="password" v-model="newItem1" />
                  </div>
                  <div class="modal-section">
                    新しいパスワードを再入力（8文字以上の半角英数）<br />
                    <input type="password" v-model="newItem2" />
                  </div>
                  <div class="modal-btn d-flex justify-content-evenly">
                    <div>
                      <button type="button" class="btn btn-red" @click="closePasswordModal()">キャンセル</button>
                    </div>
                    <div>
                      <button class="btn btn-purple" @click="changePassword()">変更</button>
                    </div>
                  </div>
                </template>
              </modal>
            </div>
          </div>
        </div>
        <!-- 表の下側の表示言語部分のdivタグ -->
        <div class="table_style">
          <div class="language table_cell h6">二段階認証</div>
          <div class="table_cell left-padding">
            <input class="visually-hidden" type="radio" name="radio-black" id="Japanese" v-model="TwoFactor" value="Two_off" />
            <label for="Japanese">無効</label>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <input class="visually-hidden" type="radio" name="radio-black" id="English" value="Two_on" v-model="TwoFactor" />
            <label for="English">有効</label>
            <button @click="changeTwoFactor()" class="btn btn-purple btn-usersetting">変更</button>
          </div>
        </div>
      </div>
    </div>
    <footerComponent />
  </div>
</template>

<style scoped>
/* 表全体のcss */
.usersetting {
  width: 90%;
  margin: auto;
  border: 1px solid;
  border-radius: 10px;
  padding-left: 15px;
  padding-right: 15px;
  color: #666666;
  background-color: #ffffff;
  white-space: nowrap; /*　（全角+半角）の文字で改行しないように */
}
/* 以下各セル特有のcss */
.table_style {
  width: 100%;
  padding: 15px 0px;
  display: table;
}
.table_cell {
  display: table-cell;
  vertical-align: middle;
}
.text-right {
  width: 115px;
  text-align: right;
}
.text-left {
  width: 0px;
  text-align: left;
}
.left-padding {
  padding-left: 15px;
}
.bottom-border {
  border-bottom: 1px solid;
}
.font-weight {
  font-weight: bolder;
}
/* 以下表の各項目のcss */
.profile {
  width: 110px;
  text-align: right;
  border-right: 1px solid;
  padding-right: 10px;
  color: #000000;
  font-weight: bold;
}
.language {
  width: 110px;
  text-align: right;
  border-right: 1px solid;
  padding-right: 10px;
  color: #000000;
  font-weight: bold;
}
.username {
  border-bottom: 1px dotted;
  padding-bottom: 10px;
  padding-top: 10px;
  height: 40px;
}
.mailaddress {
  border-bottom: 1px dotted;
  padding-bottom: 10px;
  padding-top: 10px;
  height: 40px;
}
.pasward {
  padding-bottom: 10px;
  padding-top: 10px;
  height: 40px;
}
/* 表の中のボタンのデザイン */
.btn-usersetting {
  padding: 0px 10px 0px 10px;
  height: 25px;
  margin-left: 40px;
}
/* 以下タイトル周りのcss */
#title {
  margin: 3rem 0;
}
#title img {
  width: 3rem;
  height: 3rem;
}
#title p {
  color: #333333;
}
.container {
  min-height: 80vh;
}
/* 以下ラジオボタンのcss */
label {
  position: relative;
  cursor: pointer;
  padding-left: 30px;
}
label::before,
label::after {
  content: '';
  display: block;
  border-radius: 50%;
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
}
label::before {
  background-color: #fff;
  border: 1.5px solid #ddd;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  left: 5px;
}
label::after {
  background-color: rgb(0, 0, 0);
  border-radius: 50%;
  opacity: 0;
  width: 16px;
  height: 16px;
  left: 7px;
}
input:checked + label::after {
  opacity: 1;
}
.visually-hidden {
  position: absolute;
  white-space: nowrap;
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  overflow: hidden;
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0;
}
.modal-section {
  margin-bottom: 1rem;
}
.modal-section input {
  width: 100%;
}
.modal-section__font-big {
  font-size: 1.25rem;
  font-weight: bold;
}
</style>

<script>
import { defineComponent } from 'vue';
import Button from '@/Jetstream/Button.vue';
import menubar from '@/Pages/Common/menu.vue';
import footerComponent from '@/Pages/Components/footer.vue';
import modal from '@/Pages/Components/modal.vue';
import Email from '@/Pages/Components/validateEmail.js';
import Password from '@/Pages/Components/validatePassword.js';

export default defineComponent({
  components: { menubar, Button, footerComponent, modal },
  props: {
    username: String, // ユーザー名
    mailaddress: String, // メールアドレス
    password: String, // パスワード
    language: String, // 言語
    permission: String, //権限
    twoauth: String, //二段階認証の有効/無効
  },
  data() {
    return {
      newItem0: '',
      newItem1: '',
      newItem2: '',
      TwoFactor: this.twoauth,
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    };
  },
  computed: {
    // パスワード表示するための関数
    password_hide() {
      //パスワードを伏字にする処理
      return ''.padStart(this.password.length, '*');
    },
  },
  methods: {
    // メールアドレス変更モーダルでキャンセルが押されたときの関数
    closeMailaddressModal() {
      // モーダルを閉じる
      this.$refs.mailaddress_modal.closeModal();
    },
    // メールアドレス変更モーダルで変更が押されたときの関数
    changeMailaddress() {
      try {
        Email.isInvalid(this.newItem1, '新しいメールアドレス');
        Email.isInvalid(this.newItem2, '新しいメールアドレス(確認用)');

        if (this.newItem1 !== this.newItem2) {
          throw new Error('新しいメールアドレスと新しいメールアドレス(確認用)が異なります。');
        }

        axios
          .post('/users/edit/checkmail', {
            newEmail: this.newItem1,
            newEmailConfirm: this.newItem2,
          })
          .then((res) => {
            alert(res.data.message);
          })
          .catch((err) => {
            alert(err.response.data.message);
          });
      } catch (error) {
        alert(error.message);
      }
    },
    // パスワード変更モーダルでキャンセルが押されたときの関数
    closePasswordModal() {
      // モーダルを閉じる
      this.$refs.password_modal.closeModal();
    },
    // パスワード変更モーダルで変更が押されたときの関数
    changePassword() {
      try {
        Password.isInvalid(this.newItem0, '現在のパスワード');
        Password.isInvalid(this.newItem1, '新しいパスワード');
        Password.isInvalid(this.newItem2, '新しいパスワード(確認用)');

        if (this.newItem1 !== this.newItem2) {
          throw new Error('新しいパスワードと新しいパスワード(確認用)が異なります。');
        }

        axios
          .post(route('checkpassword'), {
            oldPassword: this.newItem0,
            newPassword: this.newItem1,
            newPasswordConfirm: this.newItem2,
          })
          .then((res) => {
            alert(res.data.message);
            location.reload();
          })
          .catch((e) => {
            alert(e.response.data.message);
          });
      } catch (error) {
        if (error.message === '新しいパスワードの形式が正しくありません。入力し直してください') {
          alert('パスワードは8文字以上24文字以内で大文字・小文字・数字・記号を1文字以上含めてください。');
        } else {
          alert(error.message);
        }
      }
    },
    // アイテムをクリアする
    clearNewItem() {
      this.newItem0 = '';
      this.newItem1 = '';
      this.newItem2 = '';
    },
    // 二段階認証の有効/無効を変更するボタンが押されたときの関数
    changeTwoFactor() {
      //alert('アラートテスト'+this.TwoFactor);
      axios
        .post('/users/edit/changetwoauth', {
          TwoFactor: this.TwoFactor,
        })
        .then((res) => {
          alert(res.data);
        })
        .catch((err) => {
          console.log(err);
          alert('Postエラーです．');
        });
    },
  },
});
</script>
